import classNames from 'classnames'
import './button.css'

type Props = {
  onClick: () => void
  children: string
  className?: string
}

export const SmallButton = ({
  onClick,
  children,
  className,
  ...rest
}: Props) => {
  return (
    <div
      className={classNames('small-button', className)}
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  )
}
